import {gql} from '@apollo/client';

export const QUERY_ME = gql`
query me {
    me {
        id
        documentId
        birthdate
        blocked
        widget
        username
        email
        FIO
        avatar {
            documentId
            url
        }
        paidTill
        gender
        role {
            name
        }
    }
}`
